<template>
    <div class="container shadow bg-white rounded mt-3">
        <form>
            <div class="py-3 pb-5 order-header">
                <img src="@/assets/smartoplogo.png" alt="" width="300">
                <div class="top-right">
                    <img src="@/assets/us.svg" alt="" @click="selectCountry('US')" class="country-switcher" v-bind:class="{ 'selected': country == 'US' }">
                    &nbsp;
                    <img src="@/assets/ca.svg" alt="" @click="selectCountry('CA')" class="country-switcher" v-bind:class="{ 'selected': country == 'CA' }">
                    &nbsp;
                    <img src="@/assets/gb.svg" alt="" @click="selectCountry('UK')" class="country-switcher" v-bind:class="{ 'selected': country == 'UK' }">
                    &nbsp;
                    <h4>Dealer Order Form</h4>
                </div>
            </div>

            <b-modal ref="smartop-password" id="smartop-password" title="Enter Your Dealer Password"
                @hidden="handleClose"
                @ok="handleClose"
                @close="handleClose"
                no-close-on-backdrop>
                <b-alert variant="danger" :show="showInvalid">Invalid password. Please try again or contact us for help.</b-alert>
                <div>
                    <label for="mypassword">Enter your dealer password to access the order form.</label>
                    <b-form-input type="password" name="mypassword" v-model="password" v-on:keyup="submitPassword"></b-form-input>
                </div>
                <div slot="modal-footer">
                    <b-button @click="checkpassword()">OK</b-button>
                </div>
            </b-modal>


            <b-modal ref="smartop-intro" id="smartop-intro" title="How To Order Your Smartops">
                <span class="row">
                    <span class="col-md-3 p-3 modal-step">
                        <span class="fa-stack fa-2x">
                            <span class="fa-regular fa-circle fa-stack-2x"></span>
                            <strong class="fa-stack-1x">1</strong>
                        </span>
                    </span>
                    <span class="col-md-9 p-3">
                        Select your Country:
                        <br>
                        <b-button variant="outline-secondary" @click="selectCountry('US')" v-bind:class="{ 'btn-secondary': country == 'US' }" >
                            <img src="@/assets/us.svg" alt="" width="30px">
                        </b-button>
                        &nbsp;
                        <b-button variant="outline-secondary" @click="selectCountry('CA')" v-bind:class="{ 'btn-secondary': country == 'CA' }" >
                            <img src="@/assets/ca.svg" alt="" width="30px">
                        </b-button>
                        &nbsp;
                        <b-button variant="outline-secondary" @click="selectCountry('UK')" v-bind:class="{ 'btn-secondary': country == 'UK' }">
                            <img src="@/assets/gb.svg" alt="" width="30px">
                        </b-button>
                    </span>
                </span>

                <span class="row">
                    <span class="col-md-3 p-3 modal-step">
                        <span class="fa-stack fa-2x">
                            <span class="fa-regular fa-circle fa-stack-2x"></span>
                            <strong class="fa-stack-1x">2</strong>
                        </span>
                    </span>
                    <span class="col-md-9 p-3">
                        Enter your billing and shipping information. Include a PO number if one will be used.
                    </span>
                </span>

                <span class="row">
                    <span class="col-md-3 p-3 modal-step">
                        <span class="fa-stack fa-2x">
                            <span class="fa-regular fa-circle fa-stack-2x"></span>
                            <strong class="fa-stack-1x">3</strong>
                        </span>
                    </span>

                    <span class="col-md-9 p-3">
                        Click the <b-button class="btn-secondary btn-sm">Configure New Smartop</b-button> button to add individual covers to your order. Each Smartop is distinctly configured and you can enter receiving customer information as well for reference.
                    </span>
                </span>

                <span class="row">
                    <span class="col-md-3 p-3 modal-step">
                        <span class="fa-stack fa-2x">
                            <span class="fa-regular fa-circle fa-stack-2x"></span>
                            <strong class="fa-stack-1x">4</strong>
                        </span>
                    </span>
                    <span class="col-md-9 p-3">
                        Once all covers are configured, select the <b-button class="btn-danger btn-sm">Submit Smartop Order</b-button> button. Once we receive your order, we will verify the contents and reach out to you directly for payment options.
                    </span>
                </span>

                <div slot="modal-footer">
                    <b-button @click="hideintro()">OK, I've got it!</b-button>
                </div>
            </b-modal>

            <div class="row">
                <div class="col-md-4 order-md-3 mb-4">
                    <Cart ref="cart" v-if="(productDataLoaded)"/>
                </div>
                <div class="col-md-4 order-md-1 mb-4">
                    <Address title="Billing Address"
                             ref="billTo"
                        :value="billAddress"
                        @input="(newAddress) => {billAddress = newAddress}" />
                </div>
                <div class="col-md-4 order-md-1 mb-4">
                    <Address title="Shipping Address"
                             ref="shipTo"
                        copybilling=true
                        :value="shipAddress"
                        @input="(newAddress) => {shipAddress = newAddress}" />
                </div>
            </div>

            <b-card>
                <div slot="header">
                    <span>Completing Your Smartop Order</span>
                </div>

                For a PDF copy of our measurement guide, <a href="/pdf/Smartop%20Measurement%20Form.pdf" target="_new">click here</a>.<br />
                <br />
                Once your order is submitted, you will receive an email confirmation. You must confirm your order with this email before processing will begin. When we receive confirmation of your order, a Leisure Concepts sales representitive will contact you directly for approval and payment verification.
            </b-card>

            <footer class="my-2 text-right text-small">
                <p class="mb-5">&copy; {{ new Date().getFullYear() }} Leisure Concepts</p>
            </footer>
        </form>
    </div>
</template>

<script>
import Address from './Address.vue';
import Cart from './Cart.vue';
import sha1 from 'sha1';
const https = require('https');

export default {
    name: 'OrderForm',
    components: {
        Address,
        Cart
    },
    data() {

        return {
            showInvalid: false,
            highlightMissingFields: null,
            urlSource: 'default',
            password: '',
            passwordHash: null,
            country: 'US',
            productdata: {
              states: {
                us: [],
                ca: [],
              }
            },
            productDataLoaded: false,
            cart: [],
            po: '',
            billAddress: {
                company: '',
                fname: '',
                lname: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                phone: '',
                email: '',
                country: '',
            },
            shipAddress: {
                company: '',
                fname: '',
                lname: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
                phone: '',
                email: '',
                country: '',
            }
        }
    },
  mounted() {
    this.fetchPasswordHash();

    if (!localStorage.authenticated) {
      this.$refs['smartop-password'].show();
    } else if (!localStorage.showIntro) {
      this.$refs['smartop-intro'].show();
    }

    //Default to US data
    this.selectCountry('US');
  },
    methods: {
        hideintro() {
            localStorage.showIntro = false;
            this.$refs['smartop-intro'].hide();
        },
        selectCountry(country) {
            // If the data is already loaded and the country didn't change we don't need to do anything.
            // Without this check it was making duplicate AJAX calls each page load.
            if (this.country === country && this.productDataLoaded) {
              return;
            }

            this.country = country;
            localStorage.country = this.country;

          if (country === 'UK') {
              this.billAddress.country = 'GB';
              this.shipAddress.country = 'GB';
            } else {
              this.billAddress.country = country;
              this.shipAddress.country = country;
            }

          let headers = {
            'Content-Type': 'application/json',
            'token': process.env.VUE_APP_API_TOKEN
          };

          let url = process.env.VUE_APP_API;

          const dataApi = this.axios.create({
                httpsAgent: new https.Agent({
                    rejectUnauthorized: false
                })
            });

          this.urlSource = 'default';
          if (window.location.hostname.indexOf('bullfrog') > -1) {
            this.urlSource = 'bullfrog';
          }

            dataApi
                .get(`${url}/api/smartop-dealer/pricing/${country}?urlsource=${this.urlSource}`, {headers: headers})
                .then((response) => {
                    this.productdata = response.data;

                    // Update the cart product data so that prices change in real time if a country is changed
                    // The cart does not exist at first page load otherwise it throws and error about missing data
                    if (typeof this.$refs.cart !== 'undefined') {
                      this.$refs.cart.clearCartOnCountryChange();
                      this.$refs.cart.productdata = this.productdata;
                    }

                    // Allow us to only trigger the cart to load once the data has been returned.
                    this.productDataLoaded = true;
                })
            ;
        },
        refreshPricing() {
          let headers = {
            'Content-Type': 'application/json',
            'token': process.env.VUE_APP_API_TOKEN
          };

          let url = process.env.VUE_APP_API;

          const dataApi = this.axios.create({
                httpsAgent: new https.Agent({
                    rejectUnauthorized: false
                })
            });

          return dataApi
              .get(`${url}/api/smartop-dealer/pricing/${this.country}?urlsource=${this.urlSource}`, {headers: headers})
              .then((response) => {
                  this.productdata = response.data;

                  if (typeof this.$refs.cart !== 'undefined') {
                    this.$refs.cart.productdata = this.productdata;
                  }
              });
        },
        copyBilling() {
            for(let key in this.billAddress) {
                this.shipAddress[key] = this.billAddress[key];
            }
        },
        handleClose(bvModalEvt) {
            bvModalEvt.preventDefault();
        },
        submitPassword(e) {
          if (e.keyCode === 13) {
            this.checkpassword();
          }
        },
        fetchPasswordHash() {
          let headers = {
            'Content-Type': 'application/json',
            'token': process.env.VUE_APP_API_TOKEN
          };

          const api = this.axios.create({
            httpsAgent: new https.Agent({
              rejectUnauthorized: false
            })
          });

          api.get(process.env.VUE_APP_GO_API_URL + '/api/v1/smartop-dealer/password-hash', { headers })
            .then((response) => {
              this.passwordHash = response.data.hash;
            })
            .catch(() => {
              // Fallback to hardcoded hash if API is unreachable
              this.passwordHash = '1a8bb29d77411d87ec587b6b3e63656e3e25e137';
            });
        },
        checkpassword() {
          if (!this.passwordHash) {
            return;
          }

          if (sha1(this.password) === this.passwordHash) {
                this.$refs['smartop-password'].hide();
                localStorage.authenticated = true;
                localStorage.authDate = Date.now();
                if (!localStorage.showIntro) {
                    this.$refs['smartop-intro'].show();
                }
            } else {
                this.showInvalid = true;
                this.password = '';
            }
        }
    }
}
</script>

<style>
    .modal-step {
        text-align:center;
    }

    .top-right {
        display:flex;
        float:right;
    }

    .top-right h4 {
        display:inline-block;
        margin-bottom:0;
    }

    .country-switcher {
        cursor:pointer;
        width:30px;
    }

    .country-switcher.selected {
        border-bottom:2px solid black;
    }

    .fa-stack .fa-circle + strong {
        /*font-size: 32px;*/
        line-height: 1.8;
    }

    @media (max-width: 768px) {
        .order-header {
            text-align:center;
        }

        .top-right {
            float:none;
            justify-content: center;
            margin-top: 24px;
        }
    }
</style>
